import { Button, Row, Space } from 'antd';
import { memo } from 'react';

interface IProps {
  onCancel?: () => void;
  loading?: boolean;
  disabled?: boolean;
  okBtnHtmlType?: 'submit' | 'button';
  onOk?: () => void;
}

function BaseModalAction(props: IProps) {
  return (
    <Row justify="end">
      <Space>
        {!!props.onCancel && (
          <Button size="large" ghost type="primary" onClick={props.onCancel}>
            Hủy bỏ
          </Button>
        )}
        <Button
          size="large"
          htmlType={props.okBtnHtmlType || 'submit'}
          onClick={props.onOk}
          type="primary"
          loading={props.loading}
          disabled={props.disabled}
        >
          Lưu
        </Button>
      </Space>
    </Row>
  );
}

export default memo(BaseModalAction);
